<template>
    <span class="uppercase text-sm tracking-widest"
        :class="status_class"
    >
        {{ $t(status_text) }}

        <i class="ml-1" :class="status_icon" aria-hidden="true"></i>
    </span>
</template>

<script>
export default {
    props: {
        status: {},
    },

    computed: {
        status_class() {
            switch (this.status) {
                case 'red':
                    return 'text-red-600';
                case 'yellow':
                    return 'text-yellow-500';
                default:
                    return 'text-green-500';
            }
        },
        status_text() {
            switch (this.status) {
                case 'red':
                    return 'Late';
                case 'yellow':
                    return 'Warning';
                default:
                    return 'On Track';
            }
        },
        status_icon() {
            switch (this.status) {
                case 'red':
                    return 'fas fa-exclamation-triangle';
                case 'yellow':
                    return 'fas fa-flag';
                default:
                    return 'fas fa-check-circle';
            }
        },
    },
}
</script>
